module.exports = __webpack_public_path__ + "img/waiting-on-photo@2x.e1add126.webp";